import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const utahData = "/img/headerlogo.png";
const kpi = "/img/KPI-DASH 2.png";
const bodex = "/img/bodexLogo.png";
const pdf = "/img/pdf1.png";

const EngTable9 = ({ data }) => {
  const pdfRef = useRef();

  // Extract Values
  const labels = data.map((item) => item.agegrp_label);
  const female = data.map((item) => Number(item.total_fem_emp));
  const male = data.map((item) => Number(item.total_male_emp));

  // Analytics Summary
  const highestFemale = Math.max(...female);
  const highestFemaleGroup = labels[female.indexOf(highestFemale)];

  const highestMale = Math.max(...male);
  const highestMaleGroup = labels[male.indexOf(highestMale)];

  const chartData = {
    labels,
    datasets: [
      {
        label: "Female Employment Share (%)",
        data: female,
        backgroundColor: "#EC489960",
        borderColor: "#ec4899",
        borderWidth: 2,
      },
      {
        label: "Male Employment Share (%)",
        data: male,
        backgroundColor: "#0ea5e960",
        borderColor: "#0ea5e9",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "👩‍🦰 vs 👨 Employment Share by Age Group (2024)",
        font: { size: 18, weight: "bold" },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        title: { display: true, text: "Employment Share (%)" },
        beginAtZero: true,
      },
      x: {
        title: { display: true, text: "Age Group" },
      },
    },
  };

  // ------- PDF Export -------
  const downloadPDF = () => {
    const input = pdfRef.current;

    html2canvas(input, {
      scale: 2,
      useCORS: true,
      scrollY: -window.scrollY,
    }).then((canvas) => {
      const img = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const usableWidth = pageWidth - 10;
      const imgHeight = (canvas.height * usableWidth) / canvas.width;

      // Header
      pdf.addImage(utahData, "PNG", 58, 5, 30, 20);
      pdf.setFontSize(20);
      pdf.text("UTahData.org", 95, 20);
      pdf.line(10, 28, 200, 28);

      // Body
      pdf.addImage(img, "PNG", 5, 30, usableWidth, imgHeight);

      // Footer
      pdf.line(10, 260, 200, 260);
      pdf.addImage(utahData, "PNG", 20, 265, 25, 15);
      pdf.setFontSize(10);
      pdf.text("Built by", 50, 276);
      pdf.addImage(bodex, "PNG", 63, 268, 44, 10);
      pdf.text("using", 108, 276);
      pdf.addImage(kpi, "PNG", 122, 265, 20, 20);

      pdf.text("20250916.v3.198", 150, 276);
      pdf.text(`Downloaded: ${new Date().toLocaleDateString()}`, 140, 295);
      pdf.text(`From: ${window.location.href}`, 10, 295);

      pdf.save("employment_share_agegroup_2024.pdf");
    });
  };

  return (
    <>
      <div ref={pdfRef} className="p-6 bg-white rounded-xl shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Employment Share by Age Group (2024)
        </h2>

        {/* Summary Boxes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 text-center">
          <div className="p-4 bg-pink-100 rounded-xl shadow">
            <p className="text-gray-600 text-sm font-medium">
              Highest Female Employment Share
            </p>
            <p className="text-2xl font-bold text-pink-700">
              {highestFemaleGroup} ({highestFemale}%)
            </p>
          </div>

          <div className="p-4 bg-blue-100 rounded-xl shadow">
            <p className="text-gray-600 text-sm font-medium">
              Highest Male Employment Share
            </p>
            <p className="text-2xl font-bold text-blue-700">
              {highestMaleGroup} ({highestMale}%)
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {" "}
          {/* Table */}
          <div className="overflow-x-auto mb-6">
            <table className="w-full text-center shadow-md border rounded-lg overflow-hidden">
              <thead className="bg-gray-800 text-white">
                <tr>
                  <th className="p-2">Age Group</th>
                  <th className="p-2">Female (%)</th>
                  <th className="p-2">Male (%)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr key={row.agegrp_label} className="hover:bg-gray-100">
                    <td className="p-2">{row.agegrp_label}</td>
                    <td className="p-2 text-pink-600 font-semibold">
                      {row.total_fem_emp}
                    </td>
                    <td className="p-2 text-blue-600 font-semibold">
                      {row.total_male_emp}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Chart */}
          <div className="flex flex-col w-full overflow-x-auto bg-white rounded-lg shadow-md">
            <div className="min-w-[400px] w-full h-96 p-4">
              <Bar data={chartData} options={options} />
            </div>
          </div>
        </div>
      </div>

      {/* Export Button */}
      <div className="flex justify-center mt-4">
        <button
          onClick={downloadPDF}
          className="bg-red-700 hover:bg-red-900 px-4 py-2 text-white rounded-lg flex items-center gap-2 shadow-lg transition-transform hover:scale-105"
        >
          <span>Download as PDF</span>
          <img className="w-[1.5rem]" src={pdf} alt="Download" />
        </button>
      </div>
    </>
  );
};

export default EngTable9;
